import {styled} from "@mui/material/styles";
import {Button, Typography} from "@mui/material";

export const StyledMainTypography = styled(Typography)(({theme}) => ({
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "22px",
    letterSpacing: "-0.333333px",
    marginBottom: "5px"
}))

